import React from 'react'
import MotorPelak from '../../assets/images/pelak/motor-pelak.jpg';
import FreePelak from '../../assets/images/pelak/freePlate.png';
import BluePelak from '../../assets/images/pelak/pelak_blue.png';
import GreenPelak from '../../assets/images/pelak/pelak_green.png';
import RedPelak from '../../assets/images/pelak/pelak_red.png';
import YellowPelak from '../../assets/images/pelak/pelak_yellow.png';
import ArmyPelak from '../../assets/images/pelak/pelak_army.png';
import Pelak from '../../assets/images/pelak/pelak.png';
import DisableImg from '../../assets/images/pelak/malool2.png';

const ShowPlate = ({plate}) => {
    const specialPlate = ['ف','الف', 'ز', 'ث' ,'پ']
  return (
    <>
    { plate && plate.plate_type !== 'car' ? (
            <div>
                    <img 
                    alt={`'${plate.plate_type}'`}
                    className={`${plate.plate_type === 'motor' ? 'motor-pelak-img':'car-pelak-img'}`} 
                    src={`${plate.plate_type === 'motor' ? MotorPelak:FreePelak}`}
                    />
                    {plate.plate_type === 'motor' ? (
                        <div className='motor-pelak'>
                        <span className='up-plate'>{plate.plate_left}</span>
                        <span className='down-plate'>{plate.plate_right}</span>
                    </div>
                    ):(
                        <div className='free-pelak'>
                        <span className='left-plate'>{plate.plate_left}</span>
                        <span className='iran-plate'>{plate.plate_iran}</span>
                    </div>
                    )}
                    
                </div>
                
        ):(
            <>
                    <img 
                    alt='car-pelak'
                    className='car-pelak-img' 
                    src={`${(plate.plate_center === 'ف' || plate.plate_center === 'ز') ? BluePelak:
                    plate.plate_center === 'ش' ? ArmyPelak :
                    (plate.plate_center === 'ک' || plate.plate_center === 'ت' || plate.plate_center === 'ع') ? YellowPelak :
                    (plate.plate_center === 'پ' || plate.plate_center === 'ث') ? GreenPelak :
                    plate.plate_center === 'الف' ? RedPelak : Pelak}                    
                    `
                }
                    />
                
                    <div className={`${specialPlate.includes(plate.plate_center)?'car-pelak color': 'car-pelak'}`}>
                        <span className='left-plate'>{plate.plate_left}</span>                       
                        {plate.plate_center === 'ژ'? (
                            <img alt='disable' className='disable-img' src={DisableImg}/>
                        ):(
                            <span className='center-plate'>{plate.plate_center}</span>
                        )}
                         <span className='right-plate'>{plate.plate_right}</span>
                        <span className='iran-plate'>{plate.plate_iran}</span>
                    </div>
                </>
        )
        
    
}
    </>
  )
}

export default ShowPlate